import type { ReactNode } from "react";
import { isContentLocKey } from "./contentKeys";

type TranslateFn = (key: string, values?: Record<string, string | number>) => string;
type TranslateNodeFn = (
  key: string,
  values?: Record<string, string | number>,
) => ReactNode;

/** Resolve CMS content that may be a localization key or a legacy literal. */
export function contentText(t: TranslateFn, value: string | null | undefined): string {
  if (value == null || value === "") return "";
  return isContentLocKey(value) ? t(value) : value;
}

export function contentTextNode(
  tx: TranslateNodeFn,
  value: string | null | undefined,
): ReactNode {
  if (value == null || value === "") return "";
  return isContentLocKey(value) ? tx(value) : value;
}

/**
 * Resolve a content field using an explicit definitions map (e.g. certification
 * module loaded for the active language), with optional default-lang fallback.
 */
export function resolveContentString(
  value: string | null | undefined,
  definitions: Record<string, string> | undefined,
  fallbackDefinitions?: Record<string, string>,
): string {
  if (value == null || value === "") return "";
  if (!isContentLocKey(value)) return value;
  return definitions?.[value] ?? fallbackDefinitions?.[value] ?? "";
}
